import React from 'react';
import { Card, CardContent } from '../ui/card';

const AdminOrdersTab = ({ orders }) => {
  return (
    <div className="space-y-4">
      {orders.length === 0 ? (
        <div className="text-center py-12 text-[#7a6555]" data-testid="no-orders">No orders yet.</div>
      ) : (
        orders.map(order => (
          <Card key={order.id} className="shadow-sm border border-[#E8DFD3] bg-white" data-testid={`order-item-${order.id}`}>
            <CardContent className="p-5">
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                  <p className="font-bold text-[#2C1810] text-sm">Order #{order.id.slice(0, 8)}</p>
                  <p className="text-xs text-[#7a6555]">{new Date(order.created_at).toLocaleString()}</p>
                </div>
                <div className="flex gap-2">
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${
                    order.payment_status === 'paid' ? 'bg-green-50 text-green-700' :
                    order.payment_status === 'expired' ? 'bg-red-50 text-red-600' :
                    'bg-yellow-50 text-yellow-700'
                  }`}>
                    {order.payment_status === 'paid' ? 'Paid' : order.payment_status === 'expired' ? 'Expired' : 'Pending'}
                  </span>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${
                    order.status === 'confirmed' ? 'bg-green-50 text-green-700' :
                    order.status === 'cancelled' ? 'bg-red-50 text-red-600' :
                    'bg-gray-50 text-gray-600'
                  }`}>
                    {order.status}
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3 text-sm">
                <div>
                  <p className="text-xs text-[#7a6555]">Customer</p>
                  <p className="font-medium text-[#2C1810]">{order.customer_name}</p>
                  <p className="text-xs text-[#7a6555]">{order.customer_email} &middot; {order.customer_phone}</p>
                </div>
                <div>
                  <p className="text-xs text-[#7a6555]">Delivery Address</p>
                  <p className="text-sm text-[#2C1810]">{order.delivery_address}</p>
                </div>
              </div>
              <div className="border-t border-[#E8DFD3] pt-3">
                <div className="flex flex-wrap gap-2 mb-2">
                  {(order.items || []).map((item, idx) => (
                    <span key={idx} className="text-xs bg-[#FDF8F0] px-2 py-1 rounded-lg text-[#2C1810]">
                      {item.name} x{item.quantity}
                    </span>
                  ))}
                </div>
                <p className="text-right font-bold text-[#2C1810]">Total: {'\u20B9'}{order.total?.toFixed(0)}</p>
              </div>
            </CardContent>
          </Card>
        ))
      )}
    </div>
  );
};

export default AdminOrdersTab;
